import { UserType } from "./model/userType.model";
import { Observable } from "rxjs";

import { IClaimRequest } from "./model/claim.model";
import { BehavioralService } from "./service/behavioral.service";
import { ClaimService } from "./service/claim.service";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { IClaimResponse } from "./model/claim.model";
import { WorkflowService } from "../services/workflow.service";

@Component({
  templateUrl: "./template/loginClaimProcess.component.html",
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
      .error-message {
        display: flex;
        width: 1208px;
        padding-right: 0px;
        flex-direction: row;
        align-items: flex-start;
        gap: 10px;
        border-radius: 5px;
        border: 1px solid var(--ngp-error-light-500, #bd2b41);
        background: var(--ngp-primary-0, #fff);

        .error-message-left {
          display: flex;

          width: 5%;
          height: 72px;
          display: flex;
          padding: 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          align-self: stretch;
          border-radius: 5px 0px 0px 5px;
          background: var(--ngp-error-light-500, #bd2b41);
        }

        .error-message-middle {
          display: flex;
          width: 90%;
          height: 72px;
          display: flex;
          padding: 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          align-self: stretch;
        }

        .error-message-right {
          display: flex;
          width: 5%;
          height: 72px;
          display: flex;
          padding: 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          align-self: stretch;
        }
      }
    `,
  ],
})
export class LoginClaimProcessComponent implements OnInit {
  first_name;
  last_name;
  claim_code;
  user_type;
  mouseoverLogin;
  claim: IClaimRequest;
  iClaimResponse: IClaimResponse;
  errorResponse;
  allUserTypes: UserType[] = [];
  displayError = false;

  constructor(
    private router: Router,
    private claimService: ClaimService,
    private behavioralService: BehavioralService,
    private workflowService: WorkflowService
  ) {}

  ngOnInit(): void {
    this.allUserTypes = this.claimService.allUserTypes();
    console.log("Attempt to load...")
  }

  login(formValues) {
    this.claim = {
      first_name: formValues.first_name,
      last_name: formValues.last_name,
      claim_code: formValues.claim_code,
      user_type: this.allUserTypes[1].name,
    };
    this.claimService
      .postClaimData(this.claim)
      .subscribe((resp: IClaimResponse) => {
        //this.router.navigate(['identityiq/external/securityQuestions']);
        if (resp.user_name != "null") {
          this.behavioralService.sendClaimRequestData(this.claim);
          this.behavioralService.sendClaimData(resp);

          if (resp.status == "Valid") {
            // Save the Claim Identity
            this.workflowService.setIdentity(this.claim.first_name, this.claim.last_name, this.claim.claim_code, this.claim.user_type)
            // Go to the security questions
            this.router.navigate(["identityiq/external/securityQuestions"]);
          } else {
            this.errorResponse = resp.errors;
            this.displayError = true;
          }
        } else {
          this.errorResponse = resp.errors;
          this.displayError = true;
        }
        //this.errorResponse = "No User can be found with the provided First Name, Last Name and Claim Code. Please enter valid input or contact the IT Service Desk at servicedesk@wgu.edu or (877) 435-7948."
      });
  }

  onUserTypeChange() {
    // console.log("UserType Changed: " + this.user_type.name);
  }

  closeDisplayError() {
    this.displayError = false;
  }
}
